<template>
    <v-dialog v-model="show" width="600">
        <v-card>

            <v-toolbar dark color="primary">

                <v-toolbar-title>{{ this.t("stornoinc", "STR_STORNO") }}?</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon dark @click.stop="show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-title>

            </v-card-title>
            <v-card-text>
                {{ this.getConfirmMessage() }}
                <!--     {{t('storno','STR_CONFIRMST').replace('%s',)}}-->
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="ma-2 text--right" @click="cancelShipment">

                    {{ this.t('stornoinc', 'STR_STORNO') }}

                </v-btn>
                <v-btn @click.stop="show = false"> {{ t("common", "STR_CLOSE") }}</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>


<script>
import axios from 'axios'
import VueAxios from 'vue-axios'
export default {
    props: {
        /**
         * Shipment number that is being cancelled.
         * @type {string}
         */
        shipmentNumber: String,

        /**
         * Colli/package number that is being cancelled (optional).
         * @type {string}
         */
        colliNumber: String,

        /**
         * Controls the visibility of the modal dialog (v-model).
         * @type {boolean}
         */
        value: Boolean,


    },
    data() {
        return {
            itemNumber: ""

        };
    },

    computed: {
        show: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {

        /**
         * Replaces placeholders in the confirmation message with shipment or colli numbers.
         * 
         * @param {string} msg - Message string containing placeholders
         * @returns {string} Message with inserted shipment/colli numbers
         */
        getConfirmMessage() {


            let msg = this.t('storno','STR_CONFIRMST');
            if (this.colliNumber != "") {
                let msg = this.t('stornoinc', 'STR_CONFIRMSTCLL').replace('%s', this.colliNumber);
                return msg;
            }

            // Check if shipmentNumber is set and not null or undefined
            if (this.shipmentNumber != "") {
                let msg = this.t('stornoinc', 'STR_CONFIRMST').replace('%s', this.colliNumber);
                return msg;
               
            }

            // Return the input string as-is if neither variable is set
            return msg;
        },
        
         /**
         * Cancels the shipment by sending a request to the backend.
         * Emits appropriate events after success/failure.
         */
        cancelShipment() {
            const t = this;
            t.$store.commit('setLoadingState', true);

            let params = {
                format: "J",
                sesstoken: t.$store.getters.getToken
            }

            if (t.shipmentNumber) {
                params.paknr = t.shipmentNumber
            }
            if (t.colliNumber) {
                params.cllnr = t.colliNumber
            }



            axios({
                method: 'get', url: process.env.VUE_APP_BACKEND_STORNO, params, withCredentials: true
            })
                .then(function (response) {
                    // handle success

                    t.show = false;

                    if (response.data[0].success) {

                        t.$store.dispatch("showMessage", { type: "info", text: response.data[0].success });

                        if (t.shipmentNumber) {
                            t.$emit('shipmentCancelled', t.shipmentNumber);
                        }
                        if (t.colliNumber) {
                            t.$emit('colliCancelled', t.colliNumber);
                        }

                    } else if (response.data[0].error) {
                        t.$store.dispatch("showMessage", { type: "Error", text: response.data[0].error });
                    }

                })
                .catch(function (error) {
                    // handle error
                    t.$store.dispatch("showMessage", { type: "Error", text: error.message });

                    console.log(error);
                })
                .finally(function () {
                    // always executed

                    t.$store.commit('setLoadingState', false);

                });
        }

    }
};
</script>